import React from "react";
import Link from "components/link";
import { useSettings } from "hooks/useStore";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";
import clsx from "clsx/lite";
import getProductUrl from "utils/product-url";

const ProductSuggestions = ({ item, isMobile, toggleSearch, query }) => {
	const showType =
		!item.title.toLowerCase().includes(query.toLowerCase()) &&
		item.type.toLowerCase().includes(query.toLowerCase());

	return (
		<Link
			className={clsx("text-black text-left mb-1 md:mb-0 capitalize border border-darkGray px-2.5 py-1.5",
				isMobile && "t-search-suggestion-click")}
			onClick={toggleSearch} to={getProductUrl(item)}
		>
			{item.title}
			{showType && <span> - {item.type.toLowerCase()}</span>}
		</Link>
	);
};

const SearchSuggestions = ({ popularTerms = [], results, query }) => {
	const { toggleSearch } = useSettings(["toggleSearch"]);
	const suggestions = results?.products || popularTerms;
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });

	const displayCount = isMobile ? 4 : 6;

	return (
		<div className="search-suggestions">
			<div className="flex justify-between w-full">
				<span className="text-secondary">{results?.products ? "Suggested" : "Popular"}</span>
				{query && (
					<Link to={`/search?q=${query}`}
						onClick={toggleSearch}
						className="hidden md:flex justify-end text-base pb-1.5 t-search-all-results-click"
					>
						Show all →
					</Link>
				)}
			</div>
			<div className="search-suggestions h-10">
				{suggestions?.slice(0, displayCount).map((item, index) =>
					results?.products ? (
						<ProductSuggestions
							key={`${item.title}-${index}`}
							item={item} index={index} isMobile={isMobile}
							toggleSearch={toggleSearch}
							query={query}
						/>
					) : (
						<Link
							className={clsx("text-black text-left mb-1 md:mb-0 capitalize border border-darkGray px-2.5 py-1.5",
								isMobile && "t-search-suggestion-click")}
							key={`${item}-${index}`} onClick={toggleSearch} to={`/search?q=${item}`}
						>
							{item}
						</Link>
					)
				)}
			</div>
		</div>
	);
};

export default SearchSuggestions;